import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllSauces,
  getSingleSauceById,
  createSauce,
  updateSauce,
  deleteSauce,
} from "@/api/new-api/staff-management/menu-manage/essential-menu/sauces";

// Thunks

export const fetchAllSauces = createAsyncThunk(
  "sauces/fetchAll",
  async ({ restaurant_id, menu_id }, { rejectWithValue }) => {
    const res = await getAllSauces(restaurant_id, menu_id);
    if (res.status === "success") return res.data.sauces;
    return rejectWithValue(res.message);
  }
);

export const fetchSingleSauce = createAsyncThunk(
  "sauces/fetchOne",
  async (id, { rejectWithValue }) => {
    const res = await getSingleSauceById(id);
    if (res.status === "success") return res.data.sauce;
    return rejectWithValue(res.message);
  }
);

export const createNewSauce = createAsyncThunk(
  "sauces/create",
  async (data, { rejectWithValue }) => {
    const res = await createSauce(data);
    if (res.status === "success") return res.data.sauce;
    return rejectWithValue(res.message);
  }
);

export const updateExistingSauce = createAsyncThunk(
  "sauces/update",
  async ({ id, data }, { rejectWithValue }) => {
    const res = await updateSauce(id, data);
    if (res.status === "success") return res.data.sauce;
    return rejectWithValue(res.message);
  }
);

export const deleteSauceById = createAsyncThunk(
  "sauces/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteSauce(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State

const initialState = {
  sauces: [],
  singleSauce: null,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
};

// Slice

const sauceSlice = createSlice({
  name: "sauces",
  initialState,
  reducers: {
    clearSauceMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchAllSauces.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllSauces.fulfilled, (state, action) => {
        state.getLoading = false;
        state.sauces = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchAllSauces.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Fetch Single
      .addCase(fetchSingleSauce.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSingleSauce.fulfilled, (state, action) => {
        state.getLoading = false;
        state.singleSauce = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchSingleSauce.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Create
      .addCase(createNewSauce.pending, (state) => {
        state.createLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(createNewSauce.fulfilled, (state, action) => {
        state.createLoading = false;
        state.sauces.push(action.payload);
        state.success = "Sauce created successfully!";
        state.requestStatus = true;
      })
      .addCase(createNewSauce.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Update
      .addCase(updateExistingSauce.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(updateExistingSauce.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.sauces = state.sauces.map((sauce) =>
          sauce.id === action.payload.id ? action.payload : sauce
        );
        state.success = "Sauce updated successfully!";
        state.requestStatus = true;
      })
      .addCase(updateExistingSauce.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Delete
      .addCase(deleteSauceById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteSauceById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.sauces = state.sauces.map((item) =>
          item.id === action.payload ? { ...item, status: "archive" } : item
        );
        state.success = "Sauce deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteSauceById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSauceMessages } = sauceSlice.actions;
export default sauceSlice.reducer;
